export enum ProcessStatus {
  Unknown = 0,
  Running = 1,
  Finished = 2,
  Terminated = 3,
  Queued = 4
}
